type TranslationKeys = {
  [key: string]: string;
};

type Translations = {
  [key: string]: TranslationKeys;
};

export const translations: Translations = {
  de: {
    // Meta & General
    pageTitle: "AI-Marketingvideos für Unternehmen | Future Level Schweiz",
    pageDescription: "Professionelle Marketingvideos mit KI – Future Level spart Zeit und Kosten durch automatisierte Videoproduktion für Unternehmen in der Schweiz.",
    
    // Navigation
    home: "Startseite",
    services: "Leistungen",
    whyFutureLevel: "Warum Future Level?",
    blog: "Blog",
    contact: "Kontakt",
    
    // Service Names
    productVideos: "Produktvideos",
    explainerVideos: "Erklärvideos",
    socialMediaAds: "Social Media Ads",
    reels: "Reels",
    
    // Service Descriptions
    productVideosDesc: "Zeigen Sie Ihre Produkte im besten Licht – automatisch, schnell, überzeugend.",
    explainerVideosDesc: "Komplexe Inhalte einfach und verständlich per KI erklärt.",
    socialMediaAdsDesc: "Hochperformante Kurzvideos für Ihre Kampagnen auf Instagram, Facebook, TikTok & Co.",
    reelsDesc: "Maximale Reichweite dank trendiger KI-Reels in Ihrem Branding.",
    
    // Hero Section
    heroTitle: "Zukunftsorientiertes Videomarketing mit KI",
    heroSubtitle: "Zeit & Kosten sparen, Wirkung maximieren",
    contactUs: "Kontaktieren Sie uns",
    learnMore: "Mehr erfahren",
    
    // Why Future Level
    whyFutureLevelSubtitle: "Unsere AI-Technologie erstellt Videos schneller als jede Agentur – ohne Schauspieler, Kamera oder Studio.",
    costSaving: "Kosten sparen",
    timeSaving: "Zeit sparen",
    increaseSales: "Verkaufszahlen steigern",
    targetAudience: "Massgeschneidert für Ihre Zielgruppe",
    costSavingDesc: "Reduzieren Sie Ihre Produktionskosten um bis zu 70% im Vergleich zu herkömmlichen Videoproduktionen.",
    timeSavingDesc: "Erhalten Sie Ihre fertigen Videos innerhalb weniger Tage statt Wochen oder Monaten.",
    increaseSalesDesc: "Steigern Sie Ihre Conversion-Rate und Umsätze durch überzeugende visuelle Inhalte.",
    targetAudienceDesc: "Jedes Video wird genau auf Ihre Zielgruppe und Branche abgestimmt.",
    
    // Why KI Videos Section
    whyKIVideosTitle: "KI Social Media Videos: 300% mehr Engagement & 70% Kostenersparnis",
    whyKIVideosPoint1: "Expertenteam mit fortschrittlichen KI-Tools für Instagram, TikTok & Facebook Videos - stets auf dem neuesten Stand der Technologie",
    whyKIVideosPoint2: "Team aus ausschließlich professionellen Video-Editoren mit langjähriger Erfahrung in digitaler Videoproduktion",
    whyKIVideosPoint3: "Vollständige Fokussierung auf Ihren Erfolg durch maßgeschneiderte KI-gestützte Videostrategien",
    whyKIVideosPoint4: "Professionelles Team mit Expertise in allen Social Media Formaten (Instagram Reels, Facebook Ads, TikTok)",
    
    // Services Section
    ourServices: "Unsere Leistungen",
    servicesSubtitle: "Professionelle KI-basierte Marketingvideos, die Ihre Botschaft wirkungsvoll vermitteln.",
    
    // Testimonials
    clientTestimonials: "Kundenstimmen",
    testimonialsSubtitle: "Was unsere Kunden über uns sagen",
    testimonial1: "Die KI-Videos von Future Level haben die Conversion-Rate in unserem Online-Shop um 35% gesteigert. Unglaubliches Preis-Leistungs-Verhältnis!",
    testimonial2: "Wir nutzen die Erklärvideos für komplexe Beratungsthemen. Unsere Kunden sind begeistert, wie verständlich die Inhalte aufbereitet sind.",
    testimonial3: "Die Social Media Ads haben unserer Klinik zu einer deutlich höheren lokalen Bekanntheit verholfen. Der ROI ist beeindruckend.",
    
    // Blog Section
    latestBlogPosts: "Aktuelle Blog-Beiträge",
    blogSubtitle: "Trends und Tipps rund um Videomarketing und KI im Marketing",
    blogTitle1: "Video-Marketing Trends 2025",
    blogExcerpt1: "Welche Video-Formate und Technologien dominieren das Marketing in diesem Jahr? Einblicke und Prognosen.",
    blogTitle2: "KI im Marketing - Revolution oder Hype?",
    blogExcerpt2: "Wie Künstliche Intelligenz das Marketing nachhaltig verändert und welche Chancen sich für Unternehmen ergeben.",
    blogTitle3: "Case Study: Erfolgreiche Video-Kampagnen",
    blogExcerpt3: "Analyse von drei besonders erfolgreichen Video-Kampagnen und was Sie daraus lernen können.",
    readMore: "Weiterlesen",
    viewAllPosts: "Alle Beiträge anzeigen",
    
    // Blog Page
    blogPageTitle: "Expertenwissen: Videomarketing & KI",
    blogPageSubtitle: "Aktuelle Trends, praktische Tipps und Erfolgsgeschichten aus der Welt des KI-basierten Videomarketings",
    blogMetaDescription: "Der Future Level Blog bietet Expertenwissen zu KI-Videomarketing, Trends und Best Practices für Unternehmen in der Schweiz.",
    backToBlog: "Zurück zum Blog",
    blogContentPlaceholder: "Dieser Abschnitt enthält detaillierte Informationen zum Thema. In einer Live-Website würde hier der vollständige Artikel-Inhalt stehen.",
    blogSubheading1: "Die wichtigsten Erkenntnisse",
    blogSubheading2: "Praktische Anwendungen",
    blogSubheading3: "Fazit und Ausblick",
    blogCTA: "Möchten Sie mehr über unsere KI-Videolösungen erfahren?",
    
    // Contact Form
    contactSubtitle: "Bereit, Ihre Video-Marketingstrategie mit KI zu revolutionieren? Füllen Sie unser Kontaktformular aus – wir melden uns innerhalb von 24 Stunden.",
    fullName: "Vollständiger Name",
    email: "E-Mail",
    company: "Unternehmen",
    phone: "Telefonnummer",
    projectDescription: "Projektbeschreibung",
    send: "Absenden",
    formSubmitSuccess: "Nachricht gesendet!",
    formSubmitMessage: "Vielen Dank für Ihre Anfrage. Wir werden uns innerhalb von 24 Stunden bei Ihnen melden.",
    
    // Clients Section
    trustedBy: "Diesen Unternehmen vertrauen uns",
    
    // Footer
    footerDescription: "Future Level - Ihr Partner für KI-basierte Marketingvideos in der Schweiz. Steigern Sie Ihren Erfolg mit innovativen Videolösungen.",
    quickLinks: "Schnellzugriff",
    allRightsReserved: "Alle Rechte vorbehalten.",
    impressum: "Impressum",
    privacy: "Datenschutz",
    terms: "AGB"
  },
  
  en: {
    // Meta & General
    pageTitle: "AI Marketing Videos for Businesses | Future Level Switzerland",
    pageDescription: "Automated video production with AI – Future Level helps businesses save time and money while increasing marketing performance.",
    
    // Navigation
    home: "Home",
    services: "Services",
    whyFutureLevel: "Why Future Level?",
    blog: "Blog",
    contact: "Contact",
    
    // Service Names
    productVideos: "Product Videos",
    explainerVideos: "Explainer Videos",
    socialMediaAds: "Social Media Ads",
    reels: "Reels",
    
    // Service Descriptions
    productVideosDesc: "Showcase your products in the best light – automatically, quickly, convincingly.",
    explainerVideosDesc: "Complex content simply and comprehensibly explained by AI.",
    socialMediaAdsDesc: "High-performance short videos for your campaigns on Instagram, Facebook, TikTok & more.",
    reelsDesc: "Maximum reach thanks to trendy AI reels in your branding.",
    
    // Hero Section
    heroTitle: "Future-Oriented Video Marketing with AI",
    heroSubtitle: "Save time & costs, maximize impact",
    contactUs: "Contact Us",
    learnMore: "Learn More",
    
    // Why Future Level
    whyFutureLevelSubtitle: "Our AI technology creates videos faster than any agency – without actors, cameras, or studio production.",
    costSaving: "Cost Saving",
    timeSaving: "Time Saving",
    increaseSales: "Increase Sales",
    targetAudience: "Tailored for Your Target Audience",
    costSavingDesc: "Reduce your production costs by up to 70% compared to conventional video productions.",
    timeSavingDesc: "Receive your finished videos within days instead of weeks or months.",
    increaseSalesDesc: "Boost your conversion rate and sales with compelling visual content.",
    targetAudienceDesc: "Each video is precisely tailored to your target audience and industry.",
    
    // Why AI Videos Section
    whyKIVideosTitle: "AI Social Media Videos: 300% More Engagement & 70% Cost Savings",
    whyKIVideosPoint1: "Expert team using advanced AI tools for Instagram, TikTok & Facebook videos - always at the cutting edge of technology",
    whyKIVideosPoint2: "Team composed exclusively of professional video editors with years of experience in digital video production",
    whyKIVideosPoint3: "Complete focus on your success through customized AI-powered video strategies",
    whyKIVideosPoint4: "Professional team with expertise in all social media formats (Instagram Reels, Facebook Ads, TikTok)",
    
    // Services Section
    ourServices: "Our Services",
    servicesSubtitle: "Professional AI-based marketing videos that effectively convey your message.",
    
    // Testimonials
    clientTestimonials: "Client Testimonials",
    testimonialsSubtitle: "What our clients say about us",
    testimonial1: "Future Level's AI videos have increased the conversion rate in our online shop by 35%. Incredible value for money!",
    testimonial2: "We use the explainer videos for complex consulting topics. Our clients are thrilled with how understandably the content is prepared.",
    testimonial3: "The social media ads have helped our clinic achieve significantly higher local awareness. The ROI is impressive.",
    
    // Blog Section
    latestBlogPosts: "Latest Blog Posts",
    blogSubtitle: "Trends and tips about video marketing and AI in marketing",
    blogTitle1: "Video Marketing Trends 2025",
    blogExcerpt1: "Which video formats and technologies dominate marketing this year? Insights and forecasts.",
    blogTitle2: "AI in Marketing - Revolution or Hype?",
    blogExcerpt2: "How artificial intelligence is sustainably changing marketing and what opportunities arise for companies.",
    blogTitle3: "Case Study: Successful Video Campaigns",
    blogExcerpt3: "Analysis of three particularly successful video campaigns and what you can learn from them.",
    readMore: "Read More",
    viewAllPosts: "View All Posts",
    
    // Blog Page
    blogPageTitle: "Expert Knowledge: Video Marketing & AI",
    blogPageSubtitle: "Current trends, practical tips, and success stories from the world of AI-based video marketing",
    blogMetaDescription: "The Future Level blog offers expert knowledge on AI video marketing, trends, and best practices for businesses in Switzerland.",
    backToBlog: "Back to Blog",
    blogContentPlaceholder: "This section contains detailed information on the topic. On a live website, the full article content would be here.",
    blogSubheading1: "Key Insights",
    blogSubheading2: "Practical Applications",
    blogSubheading3: "Conclusion and Outlook",
    blogCTA: "Would you like to learn more about our AI video solutions?",
    
    // Contact Form
    contactSubtitle: "Ready to revolutionize your video marketing strategy with AI? Fill out our contact form – we'll get back to you within 24 hours.",
    fullName: "Full Name",
    email: "Email",
    company: "Company",
    phone: "Phone Number",
    projectDescription: "Project Description",
    send: "Send",
    formSubmitSuccess: "Message Sent!",
    formSubmitMessage: "Thank you for your inquiry. We will contact you within 24 hours.",
    
    // Clients Section
    trustedBy: "Trusted By These Companies",
    
    // Footer
    footerDescription: "Future Level - Your partner for AI-based marketing videos in Switzerland. Boost your success with innovative video solutions.",
    quickLinks: "Quick Links",
    allRightsReserved: "All rights reserved.",
    impressum: "Imprint",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions"
  },
  
  fr: {
    // Meta & General
    pageTitle: "Vidéos marketing avec IA pour entreprises | Future Level Suisse",
    pageDescription: "Créez des vidéos marketing avec l'intelligence artificielle – Future Level réduit les coûts et améliore votre visibilité en ligne.",
    
    // Navigation
    home: "Accueil",
    services: "Services",
    whyFutureLevel: "Pourquoi Future Level?",
    blog: "Blog",
    contact: "Contact",
    
    // Service Names
    productVideos: "Vidéos de Produits",
    explainerVideos: "Vidéos Explicatives",
    socialMediaAds: "Publicités pour Médias Sociaux",
    reels: "Reels",
    
    // Service Descriptions
    productVideosDesc: "Présentez vos produits sous leur meilleur jour – automatiquement, rapidement, de manière convaincante.",
    explainerVideosDesc: "Contenu complexe expliqué simplement et de manière compréhensible par l'IA.",
    socialMediaAdsDesc: "Vidéos courtes haute performance pour vos campagnes sur Instagram, Facebook, TikTok et plus.",
    reelsDesc: "Portée maximale grâce aux reels IA tendance à votre image de marque.",
    
    // Hero Section
    heroTitle: "Marketing Vidéo Orienté vers l'Avenir avec l'IA",
    heroSubtitle: "Économisez du temps et des coûts, maximisez l'impact",
    contactUs: "Contactez-nous",
    learnMore: "En savoir plus",
    
    // Why Future Level
    whyFutureLevelSubtitle: "Notre technologie d'IA crée des vidéos plus rapidement que n'importe quelle agence – sans acteurs, caméras ou production en studio.",
    costSaving: "Économie de Coûts",
    timeSaving: "Gain de Temps",
    increaseSales: "Augmentation des Ventes",
    targetAudience: "Adapté à Votre Public Cible",
    costSavingDesc: "Réduisez vos coûts de production jusqu'à 70% par rapport aux productions vidéo conventionnelles.",
    timeSavingDesc: "Recevez vos vidéos finies en quelques jours au lieu de semaines ou de mois.",
    increaseSalesDesc: "Augmentez votre taux de conversion et vos ventes grâce à un contenu visuel convaincant.",
    targetAudienceDesc: "Chaque vidéo est précisément adaptée à votre public cible et à votre secteur.",
    
    // Why AI Videos Section
    whyKIVideosTitle: "Vidéos AI pour médias sociaux: 300% plus d'engagement et 70% d'économie",
    whyKIVideosPoint1: "Équipe d'experts utilisant des outils d'IA avancés pour les vidéos Instagram, TikTok et Facebook - toujours à la pointe de la technologie",
    whyKIVideosPoint2: "Équipe composée exclusivement d'éditeurs vidéo professionnels avec des années d'expérience en production vidéo numérique",
    whyKIVideosPoint3: "Concentration totale sur votre succès grâce à des stratégies vidéo personnalisées basées sur l'IA",
    whyKIVideosPoint4: "Équipe professionnelle avec expertise dans tous les formats de médias sociaux (Instagram Reels, Facebook Ads, TikTok)",
    
    // Services Section
    ourServices: "Nos Services",
    servicesSubtitle: "Des vidéos marketing professionnelles basées sur l'IA qui transmettent efficacement votre message.",
    
    // Testimonials
    clientTestimonials: "Témoignages Clients",
    testimonialsSubtitle: "Ce que disent nos clients à propos de nous",
    testimonial1: "Les vidéos IA de Future Level ont augmenté le taux de conversion dans notre boutique en ligne de 35%. Un rapport qualité-prix incroyable!",
    testimonial2: "Nous utilisons les vidéos explicatives pour des sujets de conseil complexes. Nos clients sont ravis de la clarté du contenu.",
    testimonial3: "Les publicités sur les médias sociaux ont aidé notre clinique à atteindre une notoriété locale nettement plus élevée. Le ROI est impressionnant.",
    
    // Blog Section
    latestBlogPosts: "Derniers Articles de Blog",
    blogSubtitle: "Tendances et conseils sur le marketing vidéo et l'IA dans le marketing",
    blogTitle1: "Tendances du Marketing Vidéo 2025",
    blogExcerpt1: "Quels formats vidéo et technologies dominent le marketing cette année? Aperçus et prévisions.",
    blogTitle2: "L'IA dans le Marketing - Révolution ou Engouement?",
    blogExcerpt2: "Comment l'intelligence artificielle change durablement le marketing et quelles opportunités s'offrent aux entreprises.",
    blogTitle3: "Étude de Cas: Campagnes Vidéo Réussies",
    blogExcerpt3: "Analyse de trois campagnes vidéo particulièrement réussies et ce que vous pouvez en apprendre.",
    readMore: "Lire la Suite",
    viewAllPosts: "Voir Tous les Articles",
    
    // Blog Page
    blogPageTitle: "Connaissances d'Experts: Marketing Vidéo & IA",
    blogPageSubtitle: "Tendances actuelles, conseils pratiques et histoires de réussite du monde du marketing vidéo basé sur l'IA",
    blogMetaDescription: "Le blog Future Level propose des connaissances d'experts sur le marketing vidéo IA, les tendances et les meilleures pratiques pour les entreprises en Suisse.",
    backToBlog: "Retour au Blog",
    blogContentPlaceholder: "Cette section contient des informations détaillées sur le sujet. Sur un site web en direct, le contenu complet de l'article serait ici.",
    blogSubheading1: "Principaux Enseignements",
    blogSubheading2: "Applications Pratiques",
    blogSubheading3: "Conclusion et Perspectives",
    blogCTA: "Souhaitez-vous en savoir plus sur nos solutions vidéo IA?",
    
    // Contact Form
    contactSubtitle: "Prêt à révolutionner votre stratégie de marketing vidéo avec l'IA? Remplissez notre formulaire de contact – nous vous répondrons dans les 24 heures.",
    fullName: "Nom Complet",
    email: "E-mail",
    company: "Entreprise",
    phone: "Numéro de Téléphone",
    projectDescription: "Description du Projet",
    send: "Envoyer",
    formSubmitSuccess: "Message Envoyé!",
    formSubmitMessage: "Merci pour votre demande. Nous vous contacterons dans les 24 heures.",
    
    // Clients Section
    trustedBy: "Ces Entreprises Nous Font Confiance",
    
    // Footer
    footerDescription: "Future Level - Votre partenaire pour les vidéos marketing basées sur l'IA en Suisse. Boostez votre succès avec des solutions vidéo innovantes.",
    quickLinks: "Liens Rapides",
    allRightsReserved: "Tous droits réservés.",
    impressum: "Mentions Légales",
    privacy: "Politique de Confidentialité",
    terms: "Conditions Générales"
  },
  
  it: {
    // Meta & General
    pageTitle: "Video marketing con IA per aziende | Future Level Svizzera",
    pageDescription: "Produzione video automatizzata con intelligenza artificiale – Future Level ti aiuta a risparmiare tempo e denaro.",
    
    // Navigation
    home: "Home",
    services: "Servizi",
    whyFutureLevel: "Perché Future Level?",
    blog: "Blog",
    contact: "Contatto",
    
    // Service Names
    productVideos: "Video di Prodotti",
    explainerVideos: "Video Esplicativi",
    socialMediaAds: "Pubblicità per Social Media",
    reels: "Reels",
    
    // Service Descriptions
    productVideosDesc: "Mostra i tuoi prodotti nella luce migliore – automaticamente, velocemente, in modo convincente.",
    explainerVideosDesc: "Contenuti complessi spiegati in modo semplice e comprensibile dall'IA.",
    socialMediaAdsDesc: "Video brevi ad alte prestazioni per le tue campagne su Instagram, Facebook, TikTok e altro.",
    reelsDesc: "Portata massima grazie ai reels di tendenza con IA nel tuo branding.",
    
    // Hero Section
    heroTitle: "Video Marketing Orientato al Futuro con l'IA",
    heroSubtitle: "Risparmia tempo e costi, massimizza l'impatto",
    contactUs: "Contattaci",
    learnMore: "Scopri di Più",
    
    // Why Future Level
    whyFutureLevelSubtitle: "La nostra tecnologia IA crea video più velocemente di qualsiasi agenzia – senza attori, telecamere o produzione in studio.",
    costSaving: "Risparmio sui Costi",
    timeSaving: "Risparmio di Tempo",
    increaseSales: "Aumento delle Vendite",
    targetAudience: "Su Misura per il Tuo Pubblico Target",
    costSavingDesc: "Riduci i tuoi costi di produzione fino al 70% rispetto alle produzioni video convenzionali.",
    timeSavingDesc: "Ricevi i tuoi video finiti in pochi giorni anziché settimane o mesi.",
    increaseSalesDesc: "Aumenta il tuo tasso di conversione e le vendite con contenuti visivi convincenti.",
    targetAudienceDesc: "Ogni video è precisamente adattato al tuo pubblico target e al tuo settore.",
    
    // Why AI Videos Section
    whyKIVideosTitle: "Video AI per social media: 300% di engagement in più e 70% di risparmio sui costi",
    whyKIVideosPoint1: "Team di esperti che utilizzano strumenti AI avanzati per video Instagram, TikTok e Facebook - sempre all'avanguardia della tecnologia",
    whyKIVideosPoint2: "Team composto esclusivamente da editor video professionisti con anni di esperienza nella produzione video digitale",
    whyKIVideosPoint3: "Concentrazione totale sul tuo successo attraverso strategie video personalizzate basate sull'IA",
    whyKIVideosPoint4: "Team professionale con competenza in tutti i formati social media (Instagram Reels, Facebook Ads, TikTok)",
    
    // Services Section
    ourServices: "I Nostri Servizi",
    servicesSubtitle: "Video di marketing professionali basati sull'IA che trasmettono efficacemente il tuo messaggio.",
    
    // Testimonials
    clientTestimonials: "Testimonianze dei Clienti",
    testimonialsSubtitle: "Cosa dicono i nostri clienti di noi",
    testimonial1: "I video IA di Future Level hanno aumentato il tasso di conversione nel nostro negozio online del 35%. Un rapporto qualità-prezzo incredibile!",
    testimonial2: "Usiamo i video esplicativi per argomenti di consulenza complessi. I nostri clienti sono entusiasti di come i contenuti sono preparati in modo comprensibile.",
    testimonial3: "Gli annunci sui social media hanno aiutato la nostra clinica a ottenere una notorietà locale significativamente più alta. Il ROI è impressionante.",
    
    // Blog Section
    latestBlogPosts: "Ultimi Post del Blog",
    blogSubtitle: "Tendenze e consigli sul video marketing e l'IA nel marketing",
    blogTitle1: "Tendenze del Video Marketing 2025",
    blogExcerpt1: "Quali formati video e tecnologie dominano il marketing quest'anno? Approfondimenti e previsioni.",
    blogTitle2: "IA nel Marketing - Rivoluzione o Hype?",
    blogExcerpt2: "Come l'intelligenza artificiale sta cambiando in modo sostenibile il marketing e quali opportunità si presentano per le aziende.",
    blogTitle3: "Case Study: Campagne Video di Successo",
    blogExcerpt3: "Analisi di tre campagne video particolarmente riuscite e cosa puoi imparare da esse.",
    readMore: "Leggi di Più",
    viewAllPosts: "Vedi Tutti i Post",
    
    // Blog Page
    blogPageTitle: "Conoscenza di Esperti: Video Marketing & IA",
    blogPageSubtitle: "Tendenze attuali, suggerimenti pratici e storie di successo dal mondo del video marketing basato sull'IA",
    blogMetaDescription: "Il blog Future Level offre conoscenze di esperti sul video marketing IA, tendenze e best practices per le aziende in Svizzera.",
    backToBlog: "Torna al Blog",
    blogContentPlaceholder: "Questa sezione contiene informazioni dettagliate sull'argomento. Su un sito web attivo, il contenuto completo dell'articolo sarebbe qui.",
    blogSubheading1: "Principali Approfondimenti",
    blogSubheading2: "Applicazioni Pratiche",
    blogSubheading3: "Conclusione e Prospettive",
    blogCTA: "Vorresti saperne di più sulle nostre soluzioni video IA?",
    
    // Contact Form
    contactSubtitle: "Pronto a rivoluzionare la tua strategia di video marketing con l'IA? Compila il nostro modulo di contatto – ti risponderemo entro 24 ore.",
    fullName: "Nome Completo",
    email: "Email",
    company: "Azienda",
    phone: "Numero di Telefono",
    projectDescription: "Descrizione del Progetto",
    send: "Invia",
    formSubmitSuccess: "Messaggio Inviato!",
    formSubmitMessage: "Grazie per la tua richiesta. Ti contatteremo entro 24 ore.",
    
    // Clients Section
    trustedBy: "Queste Aziende Si Fidano di Noi",
    
    // Footer
    footerDescription: "Future Level - Il tuo partner per video di marketing basati sull'IA in Svizzera. Aumenta il tuo successo con soluzioni video innovative.",
    quickLinks: "Link Rapidi",
    allRightsReserved: "Tutti i diritti riservati.",
    impressum: "Impronta",
    privacy: "Informativa sulla Privacy",
    terms: "Termini e Condizioni"
  }
};
